import Reveal from "@/components/Reveal";

const STEPS = [
  {
    n: "01",
    title: "Capture",
    desc: "Patient voice is gathered across relevant evidence sources — digital conversations, patient experience research, advisory input, and real-world evidence.",
  },
  {
    n: "02",
    title: "Validate",
    desc: "AI-assisted synthesis identifies patterns and themes, which are reviewed and validated by senior HEOR and patient evidence experts.",
  },
  {
    n: "03",
    title: "Activate",
    desc: "Insights are translated into evidence-ready recommendations for Medical Affairs, HEOR, Market Access, Patient Engagement, and Brand teams.",
  },
];

export default function TransformFramework() {
  return (
    <section className="bg-ink-1 relative" data-testid="how-it-works-section">
      <div className="container-edge py-24 lg:py-32">
        <Reveal>
          <div className="eyebrow">How it works</div>
          <h2 className="font-serif font-normal text-3xl md:text-5xl lg:text-[3.5rem] tracking-tight mt-4 max-w-3xl text-parchment-bright leading-[1.05]">
            Capture → Validate → Activate.
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 border border-white/[0.08] bg-ink-2">
          {STEPS.map((s, i) => (
            <Reveal
              key={s.n}
              delay={i * 120}
              className={`relative p-8 lg:p-10 card-dark-hover ${i < 2 ? "md:border-r border-white/[0.08]" : ""} ${i < 2 ? "border-b md:border-b-0 border-white/[0.08]" : ""}`}
              data-testid={`how-step-${s.title.toLowerCase()}`}
            >
              <div className="flex items-baseline justify-between">
                <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-rust">{s.n}</span>
                {i < STEPS.length - 1 && (
                  <span className="hidden md:inline-block font-mono text-parchment/30">→</span>
                )}
              </div>
              <h3 className="font-serif text-3xl md:text-4xl mt-6 text-parchment-bright">{s.title}</h3>
              <p className="mt-5 text-parchment/70 leading-relaxed">{s.desc}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
